export const PAST_CAR_COVER_WIDTH = 216;
export const PAST_CAR_COVER_HEIGHT = 144;
